import script from "./PhotoCropper.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoCropper.vue?vue&type=script&setup=true&lang=js"

import "./PhotoCropper.vue?vue&type=style&index=0&id=08dacad0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08dacad0"]])

export default __exports__